import RESUME_LS_RECORD from 'shared-constants/src/resumeLSRecord';

import { setItem } from '@helpers/Storage';

function saveRLSRecord(dataObj) {
  console.log('saveRLSRecord', dataObj);
  const { qObject, locations, parentLocation } = dataObj;
  if (qObject) {
    window.localStorage && setItem(RESUME_LS_RECORD, JSON.stringify({
      qObject,
      locations,
      parentLocation,
      _v: '1.3',
    }));
  }
}

export default saveRLSRecord;
